<template>
  
    <div class="bg-white border border-black">

       <div class="flex lg:flex-col flex-col">
            
            <div class="flex flex-row pb-1 lg:pb-3  text-grey-dark">

                <div class="text-center ml-2 p-1 lg:p-4 w-full bg-pink-300 pl-1 lg:pl-2 mr-1 lg:mr-2">
                    
                    <!-- <span class="font-bold">{{$t('memberships.weekDays')}}</span> -->

                    <h2 class="text-pink-700">{{weekDays}}</h2>
                </div>
            </div>
                    
            <div class="flex sm:flex-row">

                 <div class="flex flex-row justify-center text-center rounded bg-pink-300
                    lg:rounded-full pl-1 pr-1 lg:p-4 mr-2 lg:mr-5 ">
                
                    <span class="font-bold mr-1 lg:mr-4">{{$t('slot.startTime')}} </span>

                    <h2 class=" text-red-700">
                        {{startTime}}
                    </h2>
                </div>

                    <div class="flex flex-row justify-center text-center rounded bg-blue-200
                    lg:rounded-full pl-1 pr-1 lg:p-4 ">
                    
                    <span class="font-bold mr-1 lg:mr-4"> {{$t('sessions.duration')}} </span>

                    <h2 class="text-pink-800">
                        {{getDuration()}}
                        </h2>
                </div>    
                    
                <div class="flex flex-row justify-center text-center rounded lg:rounded-full pl-1 pr-1 lg:p-4 ">
                    
                    <span class="font-bold mr-1 lg:mr-4">
                        
                        {{$t('slot.endTime')}}            
                    </span>
                        
                    <h2 class="text-pink-700">{{endTime}}</h2>
                </div>            
            </div> 
        </div>
    </div>
</template>

<script>

import moment from 'moment'
export default {

    mounted(){

        // console.log(`schedule is: ${JSON.stringify(this.schedule)}`);
        this.setWeekDays();
    },

    props:{

        schedule: { 

            type: Object
        }
    },

    methods:{

        getDuration(){

            // console.log(`index:${this.index} start time is: ${new Date('1970-01-01T' + this.slot.start_time  + 'Z')}`)
            const minutes = ((new Date('1970/01/01 ' + this.schedule.end_time  + '') - new Date('1970/01/01 ' + this.schedule.start_time  + ' '))/ (1000*60));
            
            let retainValue = function (value) {
                return Number.parseFloat(value).toPrecision(2);
            };
            moment.relativeTimeRounding(retainValue);
            
            const duration = moment.duration({"minutes": minutes}).humanize();
            // const duration = moment.duration({"minutes": minutes}).humanize(true);

            // console.log(`duration is ${duration}`);

            return duration;
        },

        setWeekDays(){

            if(this.schedule.monday == true){

                this.weekDays = this.weekDays + 'Monday';
            }

            if(this.schedule.tuesday == true){

                if(this.weekDays != ''){

                    this.weekDays = this.weekDays + ', ';
                }

                this.weekDays = this.weekDays + 'Tuesday';
            }

            if(this.schedule.wednesday == true){

                if(this.weekDays != ''){

                    this.weekDays = this.weekDays + ', ';
                }

                this.weekDays = this.weekDays + 'Wednesday';
            }

            if(this.schedule.thursday == true){

                if(this.weekDays != ''){

                    this.weekDays = this.weekDays + ', ';
                }

                this.weekDays = this.weekDays + 'Thursday';
            }

            if(this.schedule.friday == true){

                if(this.weekDays != ''){

                    this.weekDays = this.weekDays + ', ';
                }

                this.weekDays = this.weekDays + 'Friday';
            }

            if(this.schedule.saturday == true){

                if(this.weekDays != ''){

                    this.weekDays = this.weekDays + ', ';
                }

                this.weekDays = this.weekDays + 'Saturday';
            }

            if(this.schedule.sunday == true){

                if(this.weekDays != ''){

                    this.weekDays = this.weekDays + ', ';
                }

                this.weekDays = this.weekDays + 'Sunday';
            }   
        },
    },

    data: function(){

        return{

            weekDays: '',
    startTime: moment(new Date(`1970/01/01 ${this.schedule.start_time}`)).format('hh:mm A'),
        // startTime:  'startTime',
        endTime: moment(new Date(`1970/01/01 ${this.schedule.end_time}`)).format('hh:mm A'),

        }
    }
}
</script>

<style>

</style>